/**
 * @generated SignedSource<<06b4e46a381fa7591f6bc9443a6be7c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SalesAssociatesContentTemplateItem_salesAssociate$data = {
  readonly id: string;
  readonly name: string | null;
  readonly avatar: {
    readonly url: string;
  } | null;
  readonly " $fragmentType": "SalesAssociatesContentTemplateItem_salesAssociate";
};
export type SalesAssociatesContentTemplateItem_salesAssociate$key = {
  readonly " $data"?: SalesAssociatesContentTemplateItem_salesAssociate$data;
  readonly " $fragmentSpreads": FragmentRefs<"SalesAssociatesContentTemplateItem_salesAssociate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SalesAssociatesContentTemplateItem_salesAssociate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Avatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SalesAssociate",
  "abstractKey": null
};

(node as any).hash = "e4d39332cf5430bace658ef5246f665f";

export default node;
